import { CsiImage, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";
import imageLS from "./LandscapeSmallImage.jpg";
import imagePS from "./PortraitSmallImage.jpg";

export default () => {
	return (
		<CssColumnGrid columns={1}>
			<Text semiBold text="landscape" />
			<CsiImage size="largest" src={imageLS} />
			<Text semiBold text="portrait" />
			<CsiImage
				onClick={() => console.log("click")}
				size="largest"
				src={imagePS}
			/>
		</CssColumnGrid>
	);
};